var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeart = function SvgIconHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.079 157.558",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#daebdb",
    d: "M45.084 0c17.6.481 30.736 9.785 41.372 23.3 2.378 3.019 3.253 3.759 6.014.172C102.858 10.007 115.848.542 133.631.086c18.35-.481 33.469 9.933 40.469 27.889 8.306 21.271 6 41.79-5.336 61.386-11.831 20.457-29.072 35.764-47.878 49.493a256 256 0 0 1-27.667 17.4c-2.12 1.171-4.042 1.935-6.458.592C59.811 141.86 35.212 124 16.48 99.084 6.978 86.4.668 72.255.052 56.234c-.764-20 6.766-42.443 25.523-51.785A43.4 43.4 0 0 1 45.084 0"
  })));
};
export default SvgIconHeart;